import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { CreateAccessRolePayload } from "../types/AccessRole";

/** POST `/user/access_role/` — creates a new Role. Body shape confirmed against a real request sample: `{name, description, scope, permissions, users}`. */
export const useCreateAccessRole = () => {
  const { authHeader } = useAuth();

  return useMutation((params: CreateAccessRolePayload) => {
    return axios.post(`${env.verifyServiceUrl}user/access_role/`, params, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
